export enum PanelOrigin {
  ProfilePage,
  SettingsPage,
  SinglePageApp,
}
